import React, { useEffect, useState } from 'react';
import { Button, Row, Col , Modal} from 'react-bootstrap';
import UserService from "../controllers/UserService";
import AuthService from "../controllers/AuthService";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery';

class ReportEvaluateStudentList extends React.Component {
    constructor(props) {
        super(props);        
        // this.changeData = this.changeData.bind(this);
        this.state = {
            user: AuthService.getCurrentUser(),
            role: AuthService.getUserRole(),
            modalShowEndActivity: false,
            // name: 'นายวัศพล คนไทย',
            id: '1234',
            // text1: 'ยังไม่ได้ประเมิน',
            // text2: 'ยังไม่ได้ประเมินคุณครู',
            // text3: 'ยังประเมินเพื่อนไม่ครบ (2/3)',
            status_text1: 'waiting',
            status_text2: 'done',
            status_text3: 'inprogress',   
            students: [],
            currentStudentIdClick: null,
            roomId: props.roomId, //'60c0e14221965c37a7c1b75f'
            statusFriends: 0,
            statusTeacher: 0,
            statusSelf: 0      
        };
        
    }

    componentDidMount() {
        UserService.getFriendshipReportList(this.state.roomId).then(        
            (res) => {         
                console.log(res);       
                var allStudents = [];
                var count = 0;
                for (const [index, value] of res.data.data.entries()) {
                    
                    if(value.user.roles[0].toLowerCase() !== 'teacher') {         
                        
                        var status = [];
                        var statusOverview = 0;
                        var statusFriends = 0; //-0 not yet, 1-inprogress, 2 done
                        var statusTeacher = 0;
                        var statusSelf = 0;
                        var teacherDone = 0;
                        
                        for (const [i, v] of value.targets.entries()) {
                  
                            if(v.answerAt !== null) {
                                status.push(true);   
                                statusOverview++;     
                                if(value.user.id === v.user.id){
                                    statusSelf++;
                                }
                                else if(v.user.roles[0].toLowerCase() !== 'teacher') {
                                    statusFriends++;
                                } else if(v.user.roles[0].toLowerCase() === 'teacher') {
                                    statusTeacher++;                                    
                                }    

                            } else {
                                status.push(false);                                 
                            }

                        }

                        for (const [ii, vv] of value.others.entries()) {  
                            if(vv.answerAt !== null && vv.user.roles[0].toLowerCase() === 'teacher') {
                                teacherDone++;
                            }                            
                        }

                        allStudents[count] = {
                            'name': value.user.fullName,
                            'id': value.user.id,
                            'status': status,
                            'statusOverview': statusOverview,
                            'statusFriends': statusFriends,
                            'statusTeacher': statusTeacher,
                            'statusSelf': statusSelf,
                            'teacherDone': teacherDone,
                            'classTeacherDone': teacherDone > 0? 't-done': 't-notdone',
                            'no':  value.user.no
                        }      
                        
                        count++;
                       
                    } else {
                        
                    }           
                }
              
                allStudents.sort(function (a, b) { return a['no'] - b['no']; });
         
                this.setState({ students: allStudents });
            });
    }

    goToStudentResult(studentId,studentName) {         
            console.log(studentId,studentName)
    }
   
    selectionChange(){
        var e = document.getElementById("selection-evaluate");
        var selectValue = e.value;
        var temp = $('#search').val();
        var count1 = 1;
        if (!selectValue) { selectValue = 'all' }

        $('.div-detail').each(function(i, obj) {  
            let studentName = obj.querySelector('.student-name').innerHTML + obj.querySelector('.student-no').innerHTML;
            let isDone = obj.classList.contains('t-done')
            var checkStatus = studentName.includes(temp);

            if(
                (checkStatus && selectValue === 'done' && isDone) ||
                (checkStatus && selectValue === 'notdone' && !isDone) || 
                (checkStatus && selectValue === 'all')
            ){
                $(obj).show();
                // obj.querySelector('.order').innerHTML = count1;
                // count1++;
            } else {
                $(obj).hide();
            }
        });
    }

    exportLink(link)  {
        if (link) {
            window.open(link, '_blank').focus();
        }
      }

      exportAll()  {
        var count_elements = $('.single').length;
        console.log(count_elements);
        

        
        
        for (let i = 0; i < count_elements; i++) {
            setTimeout(() => {
                console.log(i);
                $('.single-'+i).click();
            },i*4000)
        }
      }

    render() {
        return (
            <div >              

                <div className="px-4 main-detail">
                    <Row className="px-0" >
                        
                            <Col xs={12} className="w-100 pb-3 px-0">
                                <Col className="w-100 px-0" id="search-div">
                                    <FontAwesomeIcon icon={faSearch} className="gray-text3 icon-search"></FontAwesomeIcon>
                                    <input className="form-control form-control-sm w-100 border-radius-5 search" type="text" id="search" placeholder="ค้นหา ชื่อ-นามสกุล หรือเลขที่ ..." onInput={() => this.selectionChange()} />
                                </Col>
                            </Col>
                                 
                    </Row>
                    <Row className="blue-bg py-2 mt-3">
                        <Col xs={2} md={2} className="text-center pr-0 gray-text3">เลขที่</Col>
                        <Col xs={6} md={7} className="text-center gray-text3">ชื่อ - นามสกุล</Col>                        
                        <Col xs={4} md={3} className="r-status">                       
                                <select id="selection-evaluate" class="form-control form-control-sm border-radius-5 w-100 my-4 font-sarabun"  className="selection-evaluate gray-text3" onChange={() => { this.selectionChange() }} style={{"fontSize": "13px"}}>  
                                    <option value="" selected disabled hidden>สถานะของครู</option>
                                    <option value="all">ทั้งหมด</option>
                                    <option value="done">ประเมินแล้ว</option>
                                    <option value="notdone">ยังไม่ประเมิน</option>
                                </select>                                
                        </Col>
                    </Row>
                    {
                        (this.state.students.length > 0) ? (
                            this.state.students.map((item, index) => (  
                                <Row key={index.toString()} className={`border-bottom-blue py-3 div-detail ${item.classTeacherDone}`}>
                                    <Col xs={2} md={2} className="text-center my-1"><h5 className="mb-0 font-weight-600 order student-no">{index + 1}</h5></Col>
                                    <Col xs={6} md={7} className="text-left my-1">
                                        <Row>
                                            <Col xs={12} md={12} className="text-left my-1">
                                                <h5 className="mb-0 font-weight-600 mb-1 student-name">{item.name}</h5>       
                                                <a href={`/pocketbook/student/${this.state.roomId}/${item.id}`}><h6 className="text-green-evaluate font-weight-600 click-pointer" onClick={() => { this.goToStudentResult(item.id, item.name)  }}><u>รายละเอียด</u></h6></a>             
                                            </Col>                                                                           
                                        </Row>
                                        
                                    </Col>

                                    <Col xs={4} md={3} className="text-right my-1 d-flex">                                                                         
                                        <Button className="bluesky d-inline py-1 py-md-2 px-3 px-md-5  font-sarabun-bold btn btn-primary export-btn" ><h5 className= {`mb-0 font-weight-bold single single-${index}`} onClick={() => this.exportLink(`/pocketbook/pdf/${this.state.roomId}/${item.id}`)}>Export</h5></Button>
                                    </Col>    
                                                                
                                </Row>
                            ))
                        ) : (
                            <div></div>
                        )
                    }

                        <Row>
                           
                            <div className="main-detail"> 
                            <br></br>
                                <Button className="bluesky d-inline py-1 py-md-2 px-3 px-md-5 mb-5 font-sarabun-bold btn btn-primary export-btn" ><h5 className="mb-0 font-weight-bold" onClick={() => this.exportAll()}>Export All</h5></Button>
                            </div>
                        </Row>
                                   
                </div>                            
            </div>
        )
    }
}

export default ReportEvaluateStudentList
